export default "__VITE_PUBLIC_ASSET__5019b24a__"